<div class="sidenav-header">
  <mat-nav-list>
    @for (item of menuItems(); track item.label){
    <app-menu-item [item]="item" [collapsed]="sideNavCollapsed()"></app-menu-item>
    }

  </mat-nav-list>
</div>